// extracted by mini-css-extract-plugin
export default {"modalCloseButton":"PopUp_modalCloseButton__dgT-x","menuIcon":"PopUp_menuIcon__6pYtP"};